import Seo from '@/_application/core/components/seo/seo';
import {useProductListAggregationsQuery} from '@/framework/gql/products.graphql';
import {HighlightBrand} from '@/__generated__/__types__';
import {useRouter} from 'next/router';
import {useTranslation} from 'next-i18next';
import {SortEnum} from '__generated__/__types__';
import {useProductListView} from '@/_application/modules/products/provider/product-list-view.provider';

const BrandSeo = ({brand}: {brand: HighlightBrand}) => {
    const {t} = useTranslation('common');
    const router = useRouter();
    const {category_id, p: page, product_list_order: sortBy, direction} = router.query;
    const brandName = brand?.meta_title ?? brand?.label ?? 'Hệ thống Mẹ Bầu & Em Bé đáng tin cậy nhất Việt Nam';

    // get selected category
    const localeOptions = {
        language: router.locale,
        filter: {
            brand: {eq: brand?.label},
        },
    };
    const {data: dataAggregations} = useProductListAggregationsQuery({
        variables: localeOptions,
    });
    const aggregations = dataAggregations?.products?.aggregations;
    const categoryFilter = aggregations?.find(option => option?.attribute_code === 'category_id');
    const selectedCategory =
        categoryFilter?.options?.filter(option => option?.value === category_id).at(0)?.label ?? '';

    //get sort
    const {sortFields} = useProductListView();
    const sortFieldLabel = sortFields?.filter(option => option?.value === sortBy)?.at(0)?.label;
    let directionName = '';
    if (sortBy === 'price') {
        directionName = ' ' + t(direction === SortEnum.Asc ? 'text-ascending' : 'text-descending');
    }
    const sortName = sortFieldLabel ? t(sortFieldLabel) + directionName : '';

    //get page
    const pageName = page ? `| Page ${page}` : '';

    const title = `${brandName} ${selectedCategory} ${sortName} ${pageName}`.trim();
    const description = title + ' Chính hãng Giá tốt';

    return <Seo canonical="" title={title} description={description} />;
};

export default BrandSeo;
